<template>
  <div class="c-survey__inner c-survey__bg--yellow">
    <div v-if="settings.prizeDrawEnabled" class="c-survey__bar c-survey__bg--blue">
      <div class="c-survey__bar-inner">
        <h1 class="white-text">{{ thankyou.preCode }} {{ submissionData.prizeDrawCode }}</h1>
      </div>
    </div>
    <div class="c-survey__content c-survey__content--padding">
      <!-- TODO: this shouldn't have c-survey__grid--page-three class -->
      <div class="c-survey__grid c-survey__grid--page-three">
        <div class="c-survey__thankyou-content-wrapper">
          <main v-html="thankyou.content" class="c-survey__html"></main>

          <div>
            <input
              type="text"
              v-model="submissionData.email"
              :placeholder="thankyou.emailInputPlaceholder"
              class="c-survey__email-input"
              @input="handleEmailInput"
              @focus="handleEmailFocus"
            />
            <div v-if="emailTouched && !isSubmitButtonActive && submissionData.email !== ''" class="c-survey__field-error">Please enter a valid email address to proceed</div>
          </div>

          <label class="c-survey__email-consent-wrapper">
            <input type="checkbox" v-model="submissionData.consent" :required="true" />
            <main v-html="thankyou.consent" class="c-survey__html c-survey__html--small"></main>
          </label>

          <div class="c-survey__actionbutton-row c-survey__actionbutton-row">
            <ActionButton :title="thankyou.submitLabel" :buttonAction="'submit'" :disabled="!isSubmitButtonActive"></ActionButton>
            <ActionButton
              :title="thankyou.skipLabel"
              :buttonAction="'next'"
              :muted="true"
              :requireConfirmation="true"
              :confirmationHeading="thankyou.confirmSkipHeading"
              :confirmationMessage="thankyou.confirmSkipContent"
            ></ActionButton>
          </div>

          <main v-html="thankyou.terms" class="c-survey__html c-survey__html--small"></main>
        </div>
        <div>
          <lottie-vue-player v-if="settings.prizeDrawEnabled" :src="thankyou.animationFilePrizesEnabled" :player-controls="false" :loop="true" :autoplay="true">
          </lottie-vue-player>
          <lottie-vue-player v-if="!settings.prizeDrawEnabled" :src="thankyou.animationFilePrizesDisabled" :player-controls="false" :loop="true" :autoplay="true">
          </lottie-vue-player>
        </div>
      </div>
    </div>
    <div class="c-survey__content-spacer"></div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import ActionButton from "../ActionButton.vue";
import Footer from "../Footer.vue";

export default {
  data() {
    return {
      emailTouched: false,
    };
  },
  created() {},
  components: { ActionButton },
  mounted() {},
  methods: {
    handleEmailInput() {
      this.emailTouched = true;
    },
    handleEmailFocus() {
      this.emailTouched = true;
    },
  },
  computed: {
    ...mapFields(["submissionData", "content.settings", "content.sections", "content.pages.thankyou"]),

    isSubmitButtonActive() {
      if (this.submissionData.email) {
        // check if email is valid
        const emailRegex = /\S+@\S+\.\S+/;
        if (!emailRegex.test(this.submissionData.email)) {
          return false;
        }

        return true;
      }
      return false;
    },
  },
};
</script>
